import {
  GraphExportType,
} from '../../Utils';
import {
  ILink,
  INode,
  LayoutText,
} from '../../workerStore/rings/Utils';

export interface IExportInput {
  exportType: GraphExportType;
  nodes: INode[];
  links: ILink[];
  texts: LayoutText[];
  width: number;
  height: number;
  total: number;
  title: string;
}

export const leftMargin = 100;
export const bottomMargin = 100;
export const topMargin = 50;
export const rightMargin = 50;
